<template>
	<div class="wrapperWidthTop" :class="[isHomeRanking ? 'home': 'country']">
    <v-row justify="center" class="topMask py-12 pb-4 py-md-12">
      <v-col cols="12" class="headerTopic">
        <translate>Golf Courses Ranking</translate> {{ $dayjs().year() }}
      </v-col>
      <v-col
        cols="12"
        class="d-flex justify-space-around mt-md-5 align-center"
        v-if="!currentCountry">
        <div class="boxedContent">
          <div class="titleText">{{totalCourse}}</div>
          <div class="subTitle font-weight-light" v-translate>Golf Courses</div>
        </div>
        <div class="boxedContent">
          <div class="titleText">{{totalCountry}}</div>
          <div class="subTitle font-weight-light">
            <translate :key="titleKey">Countries</translate>
          </div>
        </div>
      </v-col>
      <v-col
        cols="12"
        class="d-flex justify-space-around mt-md-5 align-center"
        v-if="currentCountry">
        <div class="boxedContentCustomWidth text-md-h3 text-h5 font-weight-bold">
          {{currentCountry.name.toUpperCase()}}
        </div>
        <div class="boxedContent">
          <div class="titleText">
            {{currentCountry && currentCountry.totalCourse || ''}}
          </div>
          <div class="subTitle font-weight-light">
            <translate :key="titleKey">Golf Courses</translate>
          </div>
          <ButtonGoogleMap v-if="$route.name === 'ranking-country'" :countryCode="currentCountry"/>
        </div>
      </v-col>

      <v-col cols="12" :md="6" :lg="6" class="text-center boxedAction">
        <SelectMultiCourse
          :placeholder="placeHolderCourse"
          class="fromSearch__search rounded-0 text-h6 font-weight-regular fromSearch__search-vlog"
          iconAppend="far fa-magnifying-glass"
          :isCourse="true"
          :action="'searchCourse'"
          :isPushLink="true"
          :multiple="false"
        />
      </v-col>
      <v-col cols="12" :md="6" :lg="6" class="text-center boxedAction">
        <SelectMultiCourse
          :placeholder="placeHolderUser"
          class="fromSearch__search rounded-0 text-h6 font-weight-regular fromSearch__search-vlog"
          iconAppend="far fa-magnifying-glass"
          :isUser="true"
          :action="'searchUser'"
          :isPushLink="true"
          :multiple="false"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader.vue';
import SelectMultiCourse from "@/components/Forms/SelectMultiCourse";
import ButtonGoogleMap from"@/components/Buttons/ButtonGoogleMap";
export default {
	name: "HeaderRanking",
  components: {AppHeader, SelectMultiCourse, ButtonGoogleMap},
  props: {
    totalCourse: { default: 31155},
    totalCountry: { default: 168},
    currentCountry: {type: Object, default: () => {}}
  },
  async mounted() {
  },
  data() {
    return {
    }
  },
  computed: {
    placeHolderCourse() {
      return this.$gettext('Search golf course')
    },
    placeHolderUser() {
      return this.$gettext('Search user')
    },
    titleKey() {
      if(!this.currentCountry) return 'worldwide'
      return this.currentCountry.name
    },
    isHomeRanking() {
      return this.$route.name === 'homepage'
    },
  },
  methods: {
  }
};
</script>
